import { put, fork, call, takeLatest, all, select } from 'redux-saga/effects';
import app from '../../app';
import {
  logoutAccountCompletion,
  unbindAccountCompletion,
  resetPassCompletion,
  resetMobileCompletion,
  loginAccountCompletion,
  bindAccountCompletion,
  editWechatCompletion,
  catchError,
} from '../../actions';

export function* watchLogoutAccount() {
  yield takeLatest('LOGOUT_ACCOUNT', function*() {
    const options = {
      url: '/api/logout',
    };
    const result = yield call(app.httpFetch, options);
    yield put(logoutAccountCompletion(result.error, result.data));
  });
}

export function* watchUnbindAccount() {
  yield takeLatest('UNBIND_ACCOUNT', function*() {
    const options = {
      url: '/api/unbind',
    };
    const result = yield call(app.httpFetch, options);
    yield put(unbindAccountCompletion(result.error, result.data));
  });
}

export function* watchLoginAccount() {
  yield takeLatest('LOGIN_ACCOUNT', function*() {
    const { type, mobile, verify, pass } = yield select(
      state => state.own.account.edit.input
    );
    let error;

    if (!mobile) {
      error = new Error('请输入账号或手机号');
    } else if (type === 'pass' && !pass) {
      error = new Error('请输入密码');
    } else if (type !== 'pass' && !verify) {
      error = new Error('请输入验证码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(loginAccountCompletion(error));
      return;
    }

    const shareUid = yield select(state => state.own.shareUid);

    const options = {
      url: '/api/loginAccount',
      method: 'POST',
      data: {
        username: mobile,
        code: verify,
        password: pass,
        type: type === 'pass' ? 2 : 1,
        shareUid,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loginAccountCompletion(result.error, result.data));
  });
}

export function* watchBindAccount() {
  yield takeLatest('BIND_ACCOUNT', function*() {
    const { type, mobile, verify, pass } = yield select(
      state => state.own.account.edit.input
    );
    let error;

    if (!mobile) {
      error = new Error('请输入手机号');
    } else if (type === 'pass' && !pass) {
      error = new Error('请输入密码');
    } else if (type !== 'pass' && !verify) {
      error = new Error('请输入验证码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(bindAccountCompletion(error));
      return;
    }

    const shareUid = yield select(state => state.own.shareUid);

    const options = {
      url: '/api/bindAccount',
      method: 'POST',
      data: {
        username: mobile,
        code: verify,
        password: pass,
        type: type === 'pass' ? 2 : 1,
        shareUid,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(bindAccountCompletion(result.error, result.data));
  });
}

export function* watchResetPass() {
  yield takeLatest('RESET_PASS', function*() {
    const { pass, passConfirm, mobile, verify } = yield select(
      state => state.own.account.edit.input
    );
    let error;

    if (!pass) {
      error = new Error('请输入密码');
    } else if (passConfirm !== pass) {
      error = new Error('两次输入的密码不一致');
    }

    if (error) {
      yield put(catchError(error));
      yield put(resetPassCompletion(error));
      return;
    }

    const options = {
      url: '/api/user/forgetPassword',
      method: 'POST',
      data: { mobile, code: verify, password: pass },
    };
    const result = yield call(app.httpFetch, options);
    yield put(resetMobileCompletion(result.error, result.data));
  });
}

export function* watchResetMobile() {
  yield takeLatest('RESET_MOBILE', function*() {
    const { mobile, verify, oldMobile, oldVerify } = yield select(
      state => state.own.account.edit.input
    );
    let error;

    if (!mobile) {
      error = new Error('请输入手机号码');
    } else if (!verify) {
      error = new Error('请输入验证码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(resetMobileCompletion(error));
      return;
    }

    const options = {
      url: '/api/user/updateMobile',
      method: 'POST',
      data: { mobile, code: verify, oldMobile, oldCode: oldVerify },
    };
    const result = yield call(app.httpFetch, options);
    yield put(resetMobileCompletion(result.error, result.data));
  });
}

export function* watchWechatEdit() {
  yield takeLatest('EDIT_WECHAT', function*() {
    const { wechat, showWechat } = yield select(
      state => state.own.account.edit.input
    );

    let error;
    if (!/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})$/.test(wechat)) {
      error = new Error(
        '微信号要求6-20个字母、数字、下划线和减号，必须以字母开头'
      );
    } else if (!(showWechat === 0 || showWechat === 1)) {
      error = new Error('请选择是否公开');
    }

    if (error) {
      yield put(catchError(error));
      yield put(editWechatCompletion(error));
      return;
    }

    const options = {
      url: '/api/user/myinfo/updateWechat',
      method: 'POST',
      data: { wechat, showWechat },
    };
    const result = yield call(app.httpFetch, options);
    yield put(editWechatCompletion(result.error, result.data));
  });
}

export default function*() {
  yield all([
    fork(watchLogoutAccount),
    fork(watchUnbindAccount),
    fork(watchLoginAccount),
    fork(watchBindAccount),
    fork(watchResetPass),
    fork(watchResetMobile),
    fork(watchWechatEdit),
  ]);
}
